export const getApiBaseUrl = () => {
  const raw = String(import.meta.env.VITE_API_BASE_URL || '');
  const trimmed = raw.replace(/\/$/, '');
  const base = trimmed.replace(/\/api$/, '');
  if (!base) {
    throw new Error('Missing VITE_API_BASE_URL');
  }
  return base;
};
